// extracted by mini-css-extract-plugin
export default {"overlay-modal":"modal_overlay-modal__umN4W","modal":"modal_modal__pp2YE","container":"modal_container__cPZg7","close":"modal_close__s7NYT","rotate":"modal_rotate__fk0IR"};